var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.082 31.082",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.067,152.757a14.4,14.4,0,1,0-14.4,14.4h0a14.42,14.42,0,0,0,14.4-14.4m-29.939,0A15.541,15.541,0,1,1,616.669,168.3a15.541,15.541,0,0,1-15.541-15.541",
    transform: "translate(-601.128 -137.215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.977,161.558l-.3-.3-.8-.8,4.1-4.1.5.5,1.529-1.53a6.429,6.429,0,1,1,.6.6l-1.53,1.53.5.5-4.1,4.1Zm19.935-8.451a12.9,12.9,0,1,0-12.9,12.9,12.9,12.9,0,0,0,12.9-12.9h0",
    transform: "translate(-601.478 -137.565)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.3,153.369a5.053,5.053,0,0,0,0-3.137,6.31,6.31,0,0,0-.732-1.484,3.784,3.784,0,0,1,0,6.107,6.4,6.4,0,0,0,.731-1.485m-.184,2.372a5.553,5.553,0,1,0-.024.024l.024-.024",
    transform: "translate(-602.822 -138.269)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill1);
export default __webpack_public_path__ + "static/media/skill1.7b076f31.svg";
export { ForwardRef as ReactComponent };